import React, { useContext, useEffect, useState } from 'react'
import { PageNumberContext } from './PageNumberContext'
import ChooseTypeCard from './ChooseTypeCard'
import { Field, useForm, useFormState } from 'react-final-form'
import { Box, TextField, Tooltip } from '@mui/material'

import GenericSelect from '../../../common/components/GenericSelect'

import MessageField from './MessageField'
import SlackMessageField from './SlackMessageField'
import { usePhoneNumberOptions } from 'src/hooks'
import SlackUploadAvatar from 'src/common/components/SlackUploadAvatar'
import { useLazyGetRandomUserProfileNameQuery } from 'src/api/simulation/simulation'
import { useParams } from 'react-router-dom'
import { LoadingButton } from '@mui/lab'

const AiIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.7598 2.66425C13.0606 2.71912 13.3455 2.81517 13.608 2.94605C13.7248 3.00428 13.8371 3.06938 13.9444 3.14085C14.2434 3.33993 14.5033 3.58824 14.7118 3.87377C14.7866 3.97627 14.8547 4.08355 14.9157 4.19507C15.0527 4.4458 15.1532 4.71798 15.2107 5.00531C15.2131 5.01717 15.2154 5.02905 15.2176 5.04097C15.2378 5.14893 15.3999 5.14893 15.4201 5.04097C15.4223 5.02905 15.4246 5.01717 15.427 5.00531C15.4844 4.71798 15.585 4.4458 15.722 4.19507C15.7829 4.08355 15.8511 3.97627 15.9259 3.87377C16.1343 3.58824 16.3943 3.33993 16.6933 3.14085C16.8006 3.06938 16.9129 3.00428 17.0296 2.94605C17.2922 2.81517 17.5771 2.71912 17.8779 2.66425C17.8903 2.66198 17.9028 2.65979 17.9152 2.65765C18.0283 2.63841 18.0283 2.48353 17.9152 2.46429C17.9028 2.46215 17.8903 2.45995 17.8779 2.45769C17.5771 2.40281 17.2922 2.30676 17.0296 2.17588C16.9129 2.11766 16.8006 2.05256 16.6933 1.98109C16.3943 1.78201 16.1343 1.53369 15.9259 1.24816C15.8511 1.14567 15.7829 1.03839 15.722 0.926869C15.585 0.676134 15.4844 0.403958 15.427 0.116641C15.4246 0.104777 15.4223 0.0928848 15.4201 0.0809703C15.3999 -0.0269901 15.2378 -0.0269901 15.2176 0.0809703C15.2154 0.0928848 15.2131 0.104777 15.2107 0.116641C15.1532 0.403958 15.0527 0.676134 14.9157 0.926866C14.8547 1.03839 14.7866 1.14567 14.7118 1.24816C14.5033 1.53369 14.2434 1.78201 13.9444 1.98109C13.8371 2.05256 13.7248 2.11766 13.608 2.17588C13.3455 2.30676 13.0606 2.40281 12.7598 2.45769C12.7474 2.45995 12.7349 2.46215 12.7224 2.46429C12.6094 2.48353 12.6094 2.63841 12.7224 2.65765C12.7349 2.65979 12.7474 2.66198 12.7598 2.66425ZM0.971254 4.4422C0.72113 4.35388 0.461207 4.28439 0.193346 4.23551C0.17368 4.23194 0.153972 4.22846 0.134219 4.22509C-0.0447395 4.19459 -0.0447395 3.9494 0.134219 3.9189C0.153972 3.91553 0.17368 3.91205 0.193346 3.90848C0.461207 3.85959 0.72113 3.79011 0.971254 3.70179C1.12094 3.64893 1.26712 3.58935 1.4094 3.52337C2.39464 3.06656 3.19255 2.30442 3.67083 1.36333C3.73988 1.22744 3.80229 1.08782 3.8576 0.944842C3.95007 0.705931 4.02281 0.457662 4.07399 0.20181C4.07773 0.183025 4.08137 0.1642 4.0849 0.145333C4.11683 -0.0256025 4.37353 -0.0256025 4.40546 0.145333C4.40899 0.1642 4.41263 0.183025 4.41637 0.20181C4.46755 0.457662 4.54029 0.705931 4.63276 0.944842C4.6881 1.08782 4.75048 1.22744 4.81956 1.36333C5.29781 2.30442 6.09572 3.06656 7.08098 3.52337C7.22325 3.58935 7.36942 3.64893 7.5191 3.70179C7.76924 3.79011 8.02915 3.85959 8.29703 3.90848C8.3167 3.91205 8.33639 3.91553 8.35614 3.9189C8.53511 3.9494 8.53511 4.19459 8.35614 4.22509C8.33639 4.22846 8.3167 4.23194 8.29703 4.23551C8.02915 4.28439 7.76924 4.35388 7.5191 4.4422C7.36942 4.49506 7.22325 4.55464 7.08098 4.62062C6.09572 5.07743 5.29781 5.83957 4.81956 6.78066C4.75048 6.91655 4.6881 7.05617 4.63276 7.19914C4.54029 7.43806 4.46755 7.68632 4.41637 7.94219C4.41263 7.96095 4.40899 7.97979 4.40546 7.99865C4.37353 8.1696 4.11683 8.1696 4.0849 7.99865C4.08137 7.97979 4.07773 7.96095 4.07399 7.94219C4.02281 7.68632 3.95007 7.43806 3.8576 7.19914C3.80229 7.05617 3.73988 6.91655 3.67083 6.78066C3.19255 5.83957 2.39464 5.07743 1.4094 4.62062C1.26712 4.55464 1.12094 4.49506 0.971254 4.4422ZM4.57826 11.7754C4.40332 11.7304 4.22596 11.6909 4.04636 11.6571C4.01828 11.6518 3.99017 11.6467 3.96201 11.6417L3.95347 11.6402L3.94192 11.6382C3.92415 11.6351 3.90464 11.6317 3.86562 11.6251L3.85199 11.6228C3.56579 11.571 3.56579 11.1796 3.85199 11.1278L3.86562 11.1255C3.90464 11.1189 3.92415 11.1155 3.94192 11.1124L3.95347 11.1104L3.96201 11.1089C3.99017 11.1039 4.01828 11.0988 4.04633 11.0935C4.22593 11.0597 4.40332 11.0202 4.57826 10.9752C4.72767 10.9367 4.87532 10.8942 5.02107 10.8478C7.37913 10.097 9.23468 8.32463 10.0207 6.07229C10.0693 5.93308 10.1138 5.79205 10.1541 5.64931C10.2012 5.48224 10.2426 5.3128 10.2779 5.14125C10.2835 5.11445 10.2888 5.08761 10.2941 5.06071L10.2957 5.05255L10.2978 5.04152C10.301 5.02477 10.3044 5.00639 10.3112 4.97007L10.3115 4.96864L10.3139 4.95562C10.3681 4.68225 10.7779 4.68225 10.832 4.95562L10.8345 4.96864C10.8415 5.00591 10.8449 5.02455 10.8482 5.04152L10.8503 5.05255L10.8519 5.06071C10.8571 5.08761 10.8625 5.11445 10.868 5.14125C10.9034 5.3128 10.9448 5.48224 10.9919 5.64931C11.0322 5.79205 11.0767 5.93308 11.1252 6.07229C11.9113 8.32463 13.7668 10.097 16.1249 10.8478C16.2706 10.8942 16.4183 10.9367 16.5677 10.9752C16.7426 11.0202 16.92 11.0597 17.0996 11.0935C17.1277 11.0988 17.1558 11.1039 17.1839 11.1089L17.1925 11.1104L17.204 11.1124L17.2223 11.1156L17.2803 11.1255L17.294 11.1278C17.5802 11.1796 17.5802 11.571 17.294 11.6228L17.2803 11.6251L17.2358 11.6327L17.204 11.6382L17.1925 11.6402L17.1839 11.6417C17.1558 11.6467 17.1277 11.6518 17.0996 11.6571C16.92 11.6909 16.7426 11.7304 16.5677 11.7754C16.4183 11.8139 16.2706 11.8564 16.1249 11.9028C13.7668 12.6536 11.9113 14.426 11.1252 16.6783C11.0767 16.8175 11.0322 16.9585 10.9919 17.1013C10.9448 17.2684 10.9034 17.4378 10.868 17.6093C10.8625 17.6361 10.8571 17.663 10.8519 17.6899L10.8503 17.698L10.8482 17.7091C10.845 17.7258 10.8415 17.7442 10.8348 17.7805L10.832 17.795C10.7779 18.0683 10.3681 18.0683 10.3139 17.795L10.3115 17.7819C10.3045 17.7448 10.301 17.726 10.2978 17.7091L10.2957 17.698L10.2941 17.6899C10.2888 17.663 10.2835 17.6361 10.2779 17.6093C10.2426 17.4378 10.2012 17.2684 10.1541 17.1013C10.1138 16.9585 10.0693 16.8175 10.0207 16.6783C9.23468 14.426 7.37913 12.6536 5.02107 11.9028C4.87532 11.8564 4.72767 11.8139 4.57826 11.7754Z'
      fill='#fff'
    />
  </svg>
)

export default function SmsWhatsappForm({ isSlack, hideTypeCard = false }) {
  const [getItems, { data, isFetching }] = useLazyGetRandomUserProfileNameQuery()
  const { values } = useFormState()
  const form = useForm()
  const { setPage } = useContext(PageNumberContext)
  const phoneNumbersOptions = usePhoneNumberOptions()
  const [touched, setTouched] = useState(false)

  useEffect(() => {
    if (data?.fullName) {
      form.change('metadata', {
        ...values.metadata,
        profileUsername: data?.fullName
      })
    }
  }, [data])

  const cardMapper = {
    AUTOMATED_EMAIL: {
      type: 'AUTOMATED_EMAIL',
      title: 'Auto-Selected Email Template',
      description: 'AI selects the best existing template from our database based on previous user simulation results',
      isAI: true,
      onChange: () => setPage(1)
    },
    AUTOMATED_AI_EMAIL: {
      type: 'AUTOMATED_AI_EMAIL',
      title: 'Fully AI-Generated Email',
      description: 'AI writes a phishing email from scratch based on past user mistakes and tools used in your company',
      isAI: true
    },
    MANUAL_EMAIL: {
      type: 'MANUAL_EMAIL',
      title: 'Custom Email',
      description: 'Choose a template or create a phishing email manually from scratch',
      isAI: false,
      onChange: () => setPage(1)
    },
    SMS: {
      type: 'SMS',
      title: 'SMS Message',
      description: 'Send a phishing test message as a text to mobile phones',
      isAI: false,
      onChange: () => setPage(1)
    },
    WHATSAPP: {
      type: 'WHATSAPP',
      title: 'WhatsApp Message',
      description: 'Send a phishing test message to selected users via WhatsApp',
      isAI: false,
      onChange: () => setPage(1)
    },
    SLACK: {
      type: 'SLACK',
      title: 'Slack Message',
      description: 'Send a phishing test message to selected users via Slack',
      isAI: false,
      onChange: () => setPage(1)
    },
    DEEP_FAKE: {
      type: 'DEEP_FAKE',
      title: 'Deepfake Call (AI-Generated)',
      description: 'Send a simulated phone call using a bot with an AI-generated voice and script',
      isAI: false,
      onChange: () => setPage(1),
      isDisabled: false
    }
  }

  const onUploadDone = url => {
    form.change('metadata', {
      ...values.metadata,
      profilePhoto: url
    })
  }

  const { id } = useParams()

  const handleRandomName = () => {
    getItems(id)
  }

  return (
    <Box display={'flex'} flexDirection={'column'} rowGap={3} pt={2}>
      {!hideTypeCard && <ChooseTypeCard {...cardMapper[values?.type]} />}
      {!isSlack && (
        <Box pl={1}>
          <Field
            name={'metadata.phoneNumber'}
            render={({ input }) => (
              <GenericSelect
                label={'Select phone number'}
                options={phoneNumbersOptions}
                value={input.value}
                onChange={input.onChange}
              />
            )}
          />
        </Box>
      )}
      {isSlack && (
        <div className='row'>
          <div style={{ width: '40%' }}>
            <SlackUploadAvatar onUploadDone={onUploadDone} defaultImage={values?.metadata?.profilePhoto} />
          </div>
          <div className='row row-center' style={{ width: '60%', paddingTop: 0, gap: 20 }}>
            <Field
              name={'metadata.profileUsername'}
              render={({ input }) => {
                return (
                  <>
                    <TextField
                      error={!values?.metadata?.profileUsername && touched}
                      label='User Full Name'
                      disabled={isFetching}
                      value={input.value}
                      onChange={e => {
                        setTouched(true)
                        const trimmedValue = e.target.value.replace(/[^\p{L}\s'-]/gu, '').trimStart()
                        input.onChange(trimmedValue)
                      }}
                      sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        '& .MuiOutlinedInput-root': {
                          fontSize: 16,
                          fontWeight: 400,
                          fontFamily: 'Plus Jakarta Sans',
                          borderRadius: '10px'
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '13px 14px 14px'
                        }
                      }}
                    />
                  </>
                )
              }}
            />
            <Tooltip arrow title='Random Name'>
              <LoadingButton
                variant={'contained'}
                sx={{
                  height: '40px',
                  background: '#6123FF',
                  borderRadius: '12px',
                  minWidth: '55px',
                  '.MuiButton-startIcon': {
                    margin: 0
                  }
                }}
                startIcon={<AiIcon />}
                onClick={handleRandomName}
                loading={isFetching}
              />
            </Tooltip>
          </div>
        </div>
      )}
      <Field name={'metadata.message'} component={isSlack ? SlackMessageField : MessageField} />
    </Box>
  )
}
